//
//
//
//
//
//
//

import index from './index';
export default {
  name: 'public',
  components: {
    index: index
  }
};